import styled from '@emotion/styled';
import {DialogActions, DialogContent} from '@mui/joy';

export const DialogText = styled.p``;

export const AmountText = styled.span`
  font-weight: ${({theme}) => theme.typography.fontWeight.bold};
`;

export const CustomDialogActions = styled(DialogActions)`
  padding-top: 0;
  flex-direction: column;
  align-items: stretch;
  gap: ${({theme}) => theme.gap.desktop.md};
`;

export const CustomDialogContent = styled(DialogContent)`
  gap: ${({theme}) => theme.gap.desktop.lg};
`;
